var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconFilter48Line = function SvgIconFilter48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.49 13.297a3.1 3.1 0 0 0-5.18 0H11v3.4h17.31a3.1 3.1 0 0 0 5.18 0H37v-3.4h-3.51ZM17.1 20.897a3.09 3.09 0 0 0-2.59 1.4H11v3.4h3.51a3.1 3.1 0 0 0 5.18 0H37v-3.4H19.73a3.06 3.06 0 0 0-2.63-1.4ZM27 29.896a3.091 3.091 0 0 0-2.59 1.4H11v3.4h13.41a3.1 3.1 0 0 0 5.18 0H37v-3.4h-7.41a3.06 3.06 0 0 0-2.59-1.4Z",
    fill: "current"
  })));
};
export default SvgIconFilter48Line;